export { IxLabelTag } from './IxLabelTag.js';
